const map = {
	"./aarreha/setup.ts": 88195,
	"./baschme/setup.ts": 4590,
	"./basland/setup.ts": 24462,
	"./bsag/setup.ts": 5054,
	"./buelach/setup.ts": 85921,
	"./chur/setup.ts": 92597,
	"./clara/setup.ts": 6946,
	"./com/setup.ts": 77940,
	"./common/setup.ts": 84644,
	"./fmi/setup.ts": 46569,
	"./fribourg/setup.ts": 38913,
	"./glarus/setup.ts": 10689,
	"./hgk/setup.ts": 84915,
	"./ipw/setup.ts": 29935,
	"./kmag/setup.ts": 75069,
	"./ksa/setup.ts": 436,
	"./ksb/setup.ts": 87881,
	"./lachen/setup.ts": 45146,
	"./liho/setup.ts": 39367,
	"./limmi/setup.ts": 62881,
	"./muri/setup.ts": 3758,
	"./puk/setup.ts": 42617,
	"./samedan/setup.ts": 2088,
	"./schaff/setup.ts": 99220,
	"./schoen/setup.ts": 20661,
	"./see/setup.ts": 32150,
	"./smn/setup.ts": 47095,
	"./soh/setup.ts": 12087,
	"./soho/setup.ts": 5370,
	"./sro/setup.ts": 33895,
	"./stgag/setup.ts": 32505,
	"./stgallen/setup.ts": 56765,
	"./szb/setup.ts": 17556,
	"./triaplus/setup.ts": 52877,
	"./triemli/setup.ts": 193,
	"./ukbal/setup.ts": 70454,
	"./ukbb/setup.ts": 65625,
	"./upkbasel/setup.ts": 91352,
	"./usz/setup.ts": 42155,
	"./winti/setup.ts": 47772,
	"./zgks/setup.ts": 33644
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54823;